"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,18.64a1.66,1.66,0,0,0-.82-1.43L20.09,14a1.66,1.66,0,0,0-2.38,2.31l.62.65h-15V1.9A1.66,1.66,0,0,0,0,1.9V18.64a1.65,1.65,0,0,0,1.66,1.65H17.8l-.63.52a1.66,1.66,0,0,0,2.09,2.57L23.39,20A1.65,1.65,0,0,0,24,18.83s0-.07,0-.1S24,18.67,24,18.64Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "9.1 13.8 11.2 10.39 13.29 13.8 16.38 13.8 12.99 8.72 16.23 3.85 13.15 3.85 11.2 7.02 9.27 3.85 6.19 3.85 9.39 8.72 6.02 13.8 9.1 13.8"
  })));
};

exports["default"] = _default;